// import Cookies from 'js-cookie'
import Config from '@/settings'

const TokenKey = Config.TokenKey

export function getToken() {
  return sessionStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function setToken(token, rememberMe) {
  sessionStorage.setItem(TokenKey, token)
  // if (rememberMe) {
  //   return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  // } else return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
  // return Cookies.remove(TokenKey)
}
